// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"f8e18b4a","839":"5c82af97"}[chunkId] + ".chunk.js";
};